import type React from 'react';

import { useBulletin } from 'hooks/useBulletin';

import classes from '../Chat.module.scss';
import { formatBulletinSummary } from '../utils/formatBulletinSummary';

interface ChatTaskBubbleProps {
  bulletinId: number | null;
  role: 'tutor' | 'student';
}

export const ChatTaskBubble: React.FC<ChatTaskBubbleProps> = ({ bulletinId, role }) => {
  const { data: bulletin, isLoading } = useBulletin(bulletinId ?? 0);

  if (!bulletinId) {
    return null;
  }

  if (isLoading) {
    return (
      <div className={classes['task-bubble']}>
        <p>Загрузка заявки...</p>
      </div>
    );
  }

  if (!bulletin) {
    return null;
  }

  const summary = formatBulletinSummary(bulletin);
  const dateLabel = bulletin.date_create
    ? new Date(bulletin.date_create).toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : '';

  return (
    <>
      {dateLabel && <div className={classes['chat-date-separator']}>{dateLabel}</div>}
      <div
        className={`${classes['task-bubble']} ${role === 'tutor' ? classes['task-bubble--tutor'] : ''}`}
      >
        <p>{summary}</p>
      </div>
    </>
  );
};
